import { format } from "date-fns";
import { de } from "date-fns/locale";

import Avatar from "~/components/Avatar";
import Headline from "~/components/Headline/Headline";
import type { User } from "~/modules/user/api/user/userTypes.ts";

type Props = {
	user: Pick<User, "firstName" | "lastName" | "avatarImage">;
};

export function DashboardHeader({ user }: Props) {
	return (
		<div className="flex items-center justify-between gap-4">
			<div className="min-w-0">
				<Headline type="h2">Moin {user.firstName}</Headline>
				<p className="text-sm text-gray-500">{format(new Date(), "EEEE, d. MMMM yyyy", { locale: de })}</p>
			</div>
			<Avatar firstName={user.firstName}
					lastName={user.lastName}
					image={user.avatarImage}
					width="size-14 md:size-20 lg:size-24"
					height="" />
		</div>
	);
}
